export default function stringShortner(str, len = 10) {
  if (!str) return null

  if (str.length <= len) return str

  return `${str.slice(0, len)}...`
}
